/**
 * Flag do modo preview do produtor, escrita pelo useAdminPreview e lida pelo
 * previewReadOnlyLink.
 *
 * Mora num módulo próprio, sem dependência nenhuma, porque quem escreve a flag
 * é um hook consumido por componente de UI (Header, MobileMenu). Se ela morasse
 * junto do ApolloLink, renderizar o Header arrastaria @apollo/client e
 * @sentry/react-native para dentro do teste — e o segundo é ESM sem transform,
 * então toda suíte que renderizasse Header quebrava em
 * `SyntaxError: Unexpected token 'export'`.
 */
let previewMode = false

export const setPreviewMode = (value: boolean) => {
  previewMode = value
}

export const isPreviewMode = () => previewMode
